import { render, staticRenderFns } from "./ApiSettings.pug?vue&type=template&id=65b51072&lang=pug&"
import script from "./ApiSettings.vue?vue&type=script&lang=js&"
export * from "./ApiSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports